import { useState } from "react";
import { supabase } from "./supabase";

const F = "'Nunito', sans-serif";
const RED = "#c0392b";
const NAVY = "#1a1a2e";

const Logo = () => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32, justifyContent: "center" }}>
    <div style={{ width: 56, height: 56, borderRadius: 14, background: RED, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <svg viewBox="0 0 100 100" width="26" height="26" fill="none">
        <g stroke="white" strokeLinecap="round" strokeLinejoin="round" fill="none">
          <polyline points="6,30 50,5 94,30" strokeWidth="5"/>
          <circle cx="28" cy="34" r="8" fill="white" stroke="none"/>
          <line x1="28" y1="42" x2="28" y2="62" strokeWidth="6"/>
          <polyline points="14,43 28,50 42,43" strokeWidth="5"/>
          <line x1="28" y1="62" x2="20" y2="78" strokeWidth="5"/>
          <line x1="28" y1="62" x2="36" y2="78" strokeWidth="5"/>
          <circle cx="70" cy="31" r="9" fill="white" stroke="none"/>
          <line x1="70" y1="40" x2="70" y2="64" strokeWidth="6"/>
          <polyline points="55,41 70,50 85,41" strokeWidth="5"/>
          <line x1="70" y1="64" x2="61" y2="80" strokeWidth="5"/>
          <line x1="70" y1="64" x2="79" y2="80" strokeWidth="5"/>
          <circle cx="49" cy="72" r="7" fill="white" stroke="none" opacity="0.9"/>
        </g>
      </svg>
    </div>
    <div>
      <div style={{ fontSize: 36, fontFamily: "Georgia, serif", fontWeight: 700, color: "#b03020", letterSpacing: "-0.02em", lineHeight: 1 }}>toto.</div>
      <div style={{ fontSize: 12, fontFamily: F, color: "#a0aec0", marginTop: 2 }}>tracking.simplified.</div>
    </div>
  </div>
);

export default function Auth({ onAuth }) {
  const defaultMode = new URLSearchParams(window.location.search).get("signup") === "true" ? "signup" : "login";
  const [mode, setMode] = useState(defaultMode);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const [resetEmail, setResetEmail] = useState("");

  const getStrength = (p) => {
    if (!p) return 0;
    let s = 0;
    if (p.length >= 8) s++;
    if (/[A-Z]/.test(p)) s++;
    if (/[0-9]/.test(p)) s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return s;
  };
  const strength = getStrength(password);
  const strengthLabel = ["", "Weak", "Fair", "Good", "Strong"][strength];
  const strengthColor = ["", "#e53e3e", "#dd6b20", "#d69e2e", "#38a169"][strength];

  const inp = {
    width: "100%", padding: "15px 16px", borderRadius: 12,
    border: "1.5px solid #e2e8f0", fontSize: 16, fontFamily: F,
    outline: "none", color: NAVY, boxSizing: "border-box",
    marginBottom: 16, background: "#fff"
  };

  // Lighten placeholder text so users don't mistake it for real input
  if (typeof document !== "undefined" && !document.getElementById("auth-placeholder-style")) {
    const s = document.createElement("style");
    s.id = "auth-placeholder-style";
    s.innerHTML = "input::placeholder{color:#CBD5E0!important;opacity:1}";
    document.head.appendChild(s);
  }

  const lbl = {
    fontSize: 14, fontFamily: F, fontWeight: 700,
    color: "#4a5568", marginBottom: 6, display: "block"
  };

  const handleReset = async () => {
    if (!resetEmail.trim()) { setError("Please enter your email address"); return; }
    setLoading(true); setError("");
    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: "https://app.totocare.app",
    });
    if (error) setError(error.message);
    else { setSuccess("Password reset email sent! Check your inbox."); setShowForgot(false); }
    setLoading(false);
  };

  const handleSubmit = async () => {
    setError(""); setSuccess(""); setLoading(true);
    if (!email || !password) { setError("Email and password required"); setLoading(false); return; }
    if (mode === "signup") {
      if (password !== confirm) { setError("Passwords do not match"); setLoading(false); return; }
      if (strength < 2) { setError("Password is too weak. Use at least 8 characters with uppercase and numbers."); setLoading(false); return; }
      const { data, error } = await supabase.auth.signUp({ email, password });
      if (error) setError(error.message);
      else if (data?.user) onAuth(data.user);
    } else {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
      else onAuth(data.user);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f7f7f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 16px", fontFamily: F }}>
      <div style={{ width: "100%", maxWidth: 460, background: "transparent", borderRadius: 24, padding: 0 }}>
  <div style={{ background: "#fff", borderRadius: 20, border: "1px solid #e8e5e0", padding: "36px 28px", boxShadow: "0 8px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.06)" }}>
        <Logo />

        <div style={{ marginBottom: 28, textAlign: "center" }}>
          <div style={{ fontSize: 28, fontWeight: 900, color: NAVY, marginBottom: 6 }}>
            {mode === "login" ? "Welcome back" : "Create your account"}
          </div>
          <div style={{ fontSize: 15, color: "#718096" }}>
            {mode === "login" ? "Sign in to your daycare dashboard" : "Get started with your 14-day free trial"}
          </div>
        </div>

        {/* Toggle */}
        <div style={{ display: "flex", background: "#ebebeb", borderRadius: 12, padding: 3, marginBottom: 28 }}>
          {["login", "signup"].map(m => (
            <button key={m} onClick={() => { setMode(m); setError(""); setSuccess(""); }}
              style={{ flex: 1, padding: "11px", borderRadius: 10, border: "none", background: mode === m ? "#fff" : "transparent", fontSize: 15, fontFamily: F, fontWeight: 700, color: mode === m ? RED : "#718096", cursor: "pointer" }}>
              {m === "login" ? "Sign in" : "Create account"}
            </button>
          ))}
        </div>

        {/* Fields */}
        <label style={lbl}>Email</label>
        <input style={inp} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" autoFocus inputMode="email" autoCapitalize="none" autoCorrect="off" />

        <label style={lbl}>Password</label>
        <input style={{ ...inp, marginBottom: 6 }} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" onKeyDown={e => e.key === "Enter" && handleSubmit()} autoComplete={mode === "signup" ? "new-password" : "current-password"} />

        {mode === "signup" && password.length > 0 && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
              {[1,2,3,4].map(i => (
                <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= strength ? strengthColor : "#e2e8f0", transition: "background 0.2s" }} />
              ))}
            </div>
            <div style={{ fontSize: 12, fontFamily: F, color: strengthColor, fontWeight: 700 }}>
              {strengthLabel} {strength < 3 ? "— use 8+ chars, uppercase, numbers & symbols" : "password"}
            </div>
          </div>
        )}

        {mode === "signup" && (
          <>
            <label style={lbl}>Confirm Password</label>
            <input style={{ ...inp, marginBottom: 8, borderColor: confirm && confirm !== password ? "#feb2b2" : "#e2e8f0" }} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="••••••••" autoComplete="new-password" />
            {confirm && confirm !== password && (
              <div style={{ fontSize: 13, fontFamily: F, color: "#e53e3e", fontWeight: 700, marginBottom: 8 }}>⚠ Passwords do not match</div>
            )}
          </>
        )}

        {mode === "login" && (
          <div style={{ textAlign: "right", marginBottom: 20 }}>
            <button onClick={() => { setShowForgot(true); setResetEmail(email); setError(""); setSuccess(""); }}
              style={{ background: "none", border: "none", fontSize: 14, fontFamily: F, fontWeight: 700, color: RED, cursor: "pointer", padding: 0 }}>
              Forgot password?
            </button>
          </div>
        )}

        {showForgot && (
          <div style={{ background: "#fff5f5", border: "1.5px solid #feb2b2", borderRadius: 14, padding: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 14, fontFamily: F, fontWeight: 700, color: NAVY, marginBottom: 10 }}>Reset your password</div>
            <input style={{ ...inp, marginBottom: 10 }} type="email" value={resetEmail} onChange={e => setResetEmail(e.target.value)} placeholder="Enter your email address" />
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setShowForgot(false)}
                style={{ flex: 1, padding: 12, borderRadius: 10, border: "1.5px solid #e2e8f0", background: "#fff", fontSize: 14, fontFamily: F, fontWeight: 700, color: "#718096", cursor: "pointer" }}>
                Cancel
              </button>
              <button onClick={handleReset} disabled={loading}
                style={{ flex: 2, padding: 12, borderRadius: 10, border: "none", background: loading ? "#e2e8f0" : RED, color: loading ? "#a0aec0" : "#fff", fontSize: 14, fontFamily: F, fontWeight: 700, cursor: "pointer" }}>
                {loading ? "Sending..." : "Send reset email"}
              </button>
            </div>
          </div>
        )}

        {error && <div style={{ background: "#fff5f5", border: "1px solid #feb2b2", borderRadius: 10, padding: "12px 16px", fontSize: 14, fontFamily: F, color: RED, fontWeight: 700, marginBottom: 16 }}>⚠ {error}</div>}
        {success && <div style={{ background: "#f0fff4", border: "1px solid #9ae6b4", borderRadius: 10, padding: "12px 16px", fontSize: 14, fontFamily: F, color: "#38a169", fontWeight: 700, marginBottom: 16 }}>✓ {success}</div>}

        <button onClick={handleSubmit} disabled={loading}
          style={{ width: "100%", padding: 17, borderRadius: 14, border: "none", background: loading ? "#e2e8f0" : RED, color: loading ? "#a0aec0" : "#fff", fontSize: 17, fontFamily: F, fontWeight: 800, cursor: loading ? "not-allowed" : "pointer" }}>
          {loading ? "Please wait..." : mode === "login" ? "Sign in →" : "Create account →"}
        </button>
      </div>
      </div>
    </div>
  );
}